import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { ReactNode } from "react";

type PageContainerProps = {
	children: ReactNode;
	pageType: string;
};

const PageContainer: React.FC<PageContainerProps> = ({ children, pageType }) => {
	return (
		<>
			<Header pageType={pageType} />
			<main className="pb-44 lg:pb-72">{children}</main>
			<Footer />
		</>
	);
};

export default PageContainer;
